import {
  OffersHistoryContainerMobile as OffersHistoryContainer,
  Provider as OffersHistoryProvider,
} from '../../../../../packages/OffersHistory';
import { useSelector } from 'react-redux';

import { Section } from 'shared/components/Section';
import { selectOffersHistory, selectOffersHistoryExists } from 'shared/selectors/offersHistory';
import { useOffersHistoryActions } from '../../hooks';
import { FC } from 'react';
import { trackBannerClick } from './tracking';

export const OffersHistoryMobileContainer: FC = () => {
  const offersHistory = useSelector(selectOffersHistory);
  const isOffersHistoryExists = useSelector(selectOffersHistoryExists);
  const actions = useOffersHistoryActions();

  if (!isOffersHistoryExists) {
    return null;
  }

  return (
    <Section>
      <OffersHistoryProvider {...offersHistory} {...actions}>
        <OffersHistoryContainer bannerText="История объявлений в этом доме" onBannerClick={trackBannerClick} />
      </OffersHistoryProvider>
    </Section>
  );
};
